<template>
  <div class="page-header filled full-block light">
    <div class="row">
      <div class="col-md-7 deal_page_container">
        <div>
          <h4 class="pointer inline-block" v-show="deal.edit=='no' || deal.edit!=deal.deal_title" @click="deal.edit=deal.deal_title; content_cache=deal.deal_title">{{deal.deal_title}}</h4>
          <input class="form-control" v-show="deal.edit==deal.deal_title" v-model="content_cache" v-on:blur="deal.edit='no'; deal.deal_title=content_cache; updateDeal(deal)" @keydown.enter="$event.target.blur()">
        </div>
        <div>
          <p class="deal_page_info pointer inline-block" v-show="deal.edit=='no' || deal.edit!=deal.deal_value" @click="deal.edit=deal.deal_value; content_cache=deal.deal_value">{{ DealPrice }}</p>
          <input class="inline-edit-input" v-show="deal.edit==deal.deal_value" v-model="content_cache" v-on:blur="deal.edit='no'; deal.deal_value=content_cache; updateDeal(deal)" @keydown.enter="$event.target.blur()">&nbsp;
          <p class="inline-block">
            <span @click="goContact(deal_contact.contact_token)" class="pointer"><i class="fa fa-user"></i>&nbsp{{deal_contact.name}}&nbsp;&nbsp;</span>
            <span @click="ShowOrganization(deal.deal_organization_token)" class="pointer"><i class="fa fa-home"></i>&nbsp{{deal.deal_organization_name}}&nbsp;&nbsp;</span>
          </p>
          <p class="pointer inline-block" v-show="deal.edit=='no' || deal.edit!=deal.deal_stage" @click="deal.edit=deal.deal_stage; stage_content_cache=deal.deal_stage"><i class="fa fa-list-ol"></i>&nbsp;{{StageName}}</p>
          <!-- FIXEME: there is an warn occure here -->
          <select v-show="deal.edit==deal.deal_stage" v-model="stage_content_cache" v-on:blur="deal.edit='no';" v-on:change="deal.edit='no'; deal.deal_stage=stage_content_cache; updateDeal(deal)" class="inline-edit-input">
            <option disabled value="">階段</option>
            <option v-for="stage in stages" v-bind:value="stage.stage_no">
              {{stage.name}}
            </option>
          </select>&nbsp;
          <p class="pointer inline-block" v-show="deal.edit=='no' || deal.edit!=deal.deal_owner" @click="deal.edit=deal.deal_owner; owner_content_cache=deal.deal_owner"><i class="fas fa-link"></i>&nbsp;{{deal.deal_owner}}</p>
          <select v-show="deal.edit==deal.deal_owner" v-model="owner_content_cache" v-on:blur="deal.edit='no';" v-on:change="deal.edit='no'; deal.deal_owner=owner_content_cache; updateDealOwner(deal)" class="inline-edit-input">
            <option v-for="user in company_users" v-bind:value="user.name">
              {{user.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-5 deal_status_btns">
        <div>
          <div role="group" aria-label="..." class="btn-group">
            <button @click="goDeal(deal.deal_token)" class="btn btn-default" v-bind:class="{ active: router=='deal'}"><i class="fas fa-shopping-bag"></i> 銷售管理</button>
            <button @click="goDealManagement(deal.deal_token)" class="btn btn-default" v-bind:class="{ active: router=='deal_management'}"><i class="fa fa-list-ol"></i> 專案管理</button>
            <button @click="goDealFinance(deal.deal_token)" class="btn btn-default" v-bind:class="{ active: router=='deal_finance'}"><i class="fas fa-dollar-sign"></i> 帳款管理</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'deal_header',
  data() {
    return {
      router: this.$route.name,
      content_cache: '',
      stage_content_cache: '',
      owner_content_cache: '',
    }
  },
  created() {

  },
  props: ['deal','deal_contact','stages','company_users','deal_activities'],
  computed: {
    DealPrice() {
      if(this.deal)
        return 'NT$' + this.deal.deal_value.toLocaleString();
    },
    StageName() {
      if(this.stages && this.deal)
        return this.stages[this.deal.deal_stage].name
    }
  },
  methods: {
    updateDeal(deal) {
      const vm = this;
      this.axios.put('deals/:id', {
        deal: {
          title: deal.deal_title,
          value: deal.deal_value,
          stage: deal.deal_stage,
          deal_token: deal.deal_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    updateDealOwner(deal){
      // get deal_owner_id
      var user_names = $(this.company_users).map(function(){ return this.name;})
      var new_deal_owner_id = this.company_users[$.inArray(deal.deal_owner, user_names)].value

      const vm = this;
      this.axios.put('deals/update_deal_owner', {
        deal: {
          deal_owner: new_deal_owner_id,
          deal_token: deal.deal_token
        }
      })
      .then(function(response) {
        if (response.status == 200) {
          console.log(response)
          vm.deal_activities.unshift(response['data']['data']['activity'])
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    goContact(contact_token) {
      this.$router.push({ name: 'contact', params: { contact_token: contact_token } })
    },
    goDeal(deal_token) {
      this.$router.push({ name: 'deal', params: { deal_token: deal_token } })
    },
    goDealManagement(deal_token){
      this.$router.push({ name: 'deal_management', params: { deal_token: deal_token } })
    },
    goDealFinance(deal_token) {
      this.$router.push({ name: 'deal_finance', params: { deal_token: deal_token } })
    },
  }
}
</script>


// WEBPACK FOOTER //
// DealHeader.vue?021fda9c